import {POLICY_MARKET_SIZE} from "../../configs/policies";
import {getRandomPolicyForMarket} from "./getRandomPolicyForMarket";

export const getNewPolicyMarket = () => {
  const market = [];

  for (let i = 0; i < POLICY_MARKET_SIZE; i++) {
    market.push(getRandomPolicyForMarket());
  }

  return market;
}